var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("td", { staticClass: "z-table-col z-table-col--body" }, [
    _vm.isMobile() || _vm.isTablet() || _vm.isVTablet()
      ? _c("span", {
          staticClass: "z-table-col__title",
          domProps: { innerHTML: _vm._s(_vm.data[_vm.index]) },
        })
      : _vm._e(),
    _vm._v(" "),
    _c("span", { staticClass: "z-table-col__content" }, [_vm._t("default")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }